export const DEFAULT_PERIODS_PER_DAY = 48;
export const HOURS_PER_DAY = 24;
export const MINUTES_PER_HOUR = 60;
export const DEFAULT_TIMEZONE = 'Europe/London';
